import type { TOC } from '@ember/component/template-only';

interface OnboardingCommonTopComponentInterface {
	Element: HTMLDivElement;
	Args: {
		title: string;
		subtitle?: string;
	};
}

const OnboardingCommonTopComponent: TOC<OnboardingCommonTopComponentInterface> = <template>
	<div class="onboarding-top smart-center-pos">
		<div class="container">
			<h2>{{@title}}</h2>
			{{#if @subtitle}}
				<p>{{@subtitle}}</p>
			{{/if}}
		</div>
	</div>
</template>;

export default OnboardingCommonTopComponent;
